export default "__VITE_ASSET__8Hya7qL9A0HZa7wYzK3OEg__"